import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

const CommercialInfosComponent = ({ musicLive, showSpotModal }) => (
    <React.Fragment>
        <div className="commercial-infos">
            <header>
                <h2>Break Comercial</h2>
            </header>
            <div className="info-box" style={{ backgroundColor: musicLive.clientColor || '#f3f3f3' }}>
                <h3 className="commercial-info-title">
                    {`${musicLive.artist} - ${musicLive.song}`}
                </h3>
                {
                    musicLive.clientDescription ?
                        <React.Fragment>
                            <div
                                className="commercial-info-content"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: musicLive.clientDescription }}
                            />
                            {musicLive.spotSlug &&
                                <Button
                                    className="commercial-info-button"
                                    title="Saiba mais sobre esse spot"
                                    onClick={() => {
                                        // Note: This will also log to AoVivo (but maybe we should add an indication that this modal was opened from aovivo?)
                                        showSpotModal(musicLive.spotSlug);
                                    }}
                                >
                                    Saiba mais sobre esse anúncio
                                </Button>}
                        </React.Fragment> :
                        <React.Fragment>
                            {musicLive.spotSlug &&
                            <Button
                                className="commercial-info-button"
                                title="Saiba mais sobre esse spot"
                                onClick={() => {
                                // Note: This will also log to AoVivo (but maybe we should add an indication that this modal was opened from aovivo?)
                                    showSpotModal(musicLive.spotSlug);
                                }}
                            >
                                Saiba mais sobre esse anúncio
                            </Button>}
                            <div className="commercial-info-content">
                                Inovação e tecnologia em todas as plataformas!
                                <br />
                                Este é mais um formato comercial ANTENA 1.
                                <br />
                                {/* eslint-disable-next-line max-len */}
                                Um espaço dedicado a complementar as campanhas audíveis de nossos anunciantes com imagem, texto e link para o ambiente da marca.
                                <br />
                                Traga sua campanha para a número 1 em música!
                                <br />
                                <br />
                                <Button className="commercial-info-anuncie-button" title="Saiba como anunciar conosco" to="/anuncie-conosco">
                                    Clique aqui e saiba mais sobre este formato comercial
                                </Button>
                            </div>
                        </React.Fragment>
                }
            </div>
        </div>
        <div className="commercial-footer">
            <h3 className="commercial-footer-title">Divulgue sua empresa</h3>
            <div className="commercial-footer-text">
                Entre em contato com nossa equipe de vendas para mais informações.
                <Button className="commercial-footer-button" title="Saiba como anunciar conosco" to="/anuncie-conosco">
                    Clique aqui para saber como anunciar conosco
                </Button>
            </div>
        </div>
    </React.Fragment>
);

CommercialInfosComponent.propTypes = exact({
    musicLive: PropTypes.object.isRequired,
    showSpotModal: PropTypes.func.isRequired,
});

export default CommercialInfosComponent;
